import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--grey-1);
    opacity: 0.5;
    z-index: 8000000000;
  }

  .confirm {
    position: absolute;
    z-index: 8000000001;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 300px;
    line-height: 1.3em;

    background: white;
    padding: 2rem 2.5rem;
    border-radius: 15px;

    .buttons {
      margin-top: 10px;
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: center;
      gap: 1rem;

      button {
        /* margin-right: 1rem;

        &:last-child {
          margin-right: 0;
        } */
      }

      button.cancel {
        background: none !important;
        color: var(--primary-cta) !important;
        border: 2px solid var(--primary-cta) !important;
      }
    }
  }
`;
